<template>
  <CRow>
    <CCol col="4">
      <CRow>
        <CCol col="2" class="align-self-center">Hiển thị</CCol>
        <CCol col="2" class="px-0">
          <b-form-select v-model="itemsPerPage" :options="itemsPerPageList"
                         value-field="value" text-field="text"
                         @change="onChangeItemsPerPage"></b-form-select>
        </CCol>
        <CCol col="8" class="align-self-center">- Tổng số: <span
          class="text-danger font-weight-bold">{{ fNumber(totalRows) }}</span> bản tin
        </CCol>
      </CRow>
    </CCol>
    <CCol :col="{size: 4, offset: 4}">
      <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="itemsPerPage"
                    first-number last-number class="mb-0 float-right"
                    @page-click="onPaginationClick" @change="onChangePagination">
        <template #prev-text>
          <CIcon name="cil-chevron-left" class="text-danger ic-chevron-left"></CIcon>
        </template>
        <template #next-text>
          <CIcon name="cil-chevron-right" class="text-success ic-chevron-right"></CIcon>
        </template>
      </b-pagination>
    </CCol>
  </CRow>
</template>

<script>
import {ITEMS_PER_PAGE} from '@/common/Constant'
import {format} from '@/mixins/format'

export default {
  name: "CcPagination",
  mixins: [
    format
  ],
  data() {
    return {
      currentPage: 1,
      itemsPerPageList: ITEMS_PER_PAGE,
      itemsPerPage: 30
    }
  },
  props: {
    totalRows: {
      type: Number,
      default: 0
    }
  },
  methods: {
    onPaginationClick(el, page) {
      const _dataEmit = {
        elem: el,
        page: page
      }
      this.$emit('onPaginationClick', _dataEmit)
    },
    onChangePagination(page) {
      this.$emit('onChangePagination', page)
    },
    onChangeItemsPerPage(selectedItem) {
      this.currentPage = 1
      this.$emit('onChangeItemsPerPage', selectedItem)
    }
  }
}
</script>

<style scoped>

</style>
